import { Outlet } from 'react-router-dom';
import Footer from '../layout/Footer';
import Header from '../layout/Header';

const GeneralRoute = () => {  
  return (
    <>
      <Header />
      <div className="layout-general">
        <Outlet />
        <Footer />
      </div>
    </>
  );
};


export default GeneralRoute;